module.exports = __webpack_public_path__ + "img/在线课程@2x.4c8ac148.png";